var _loginValidation;
var _forgottenPasswordValidation;
var _productValidation;
var _userValidation;

$(document).ready(function(){
	//VALIDATION
	_loginValidation = new FirstwebValidation("loginForm");
	_forgottenPasswordValidation = new FirstwebValidation("forgottenPassForm");
	_productValidation = new FirstwebValidation("formStep0");
	_userValidation = new FirstwebValidation("formStep1");
	initLoginValidation();
	initForgottenPasswordValidation();
	initProductValidation();
	initUserValidation();
	$(".loginForm").on("submit", validateLogin);
	$(".forgottenPassForm").on("submit", validateForgottenPassword);
	$(".formStep1").on("submit", validateUser);

	//CUSTOM DATEPICKER AND SELECTMENU JQUERYUI
	initDatePicker();
	initSelectMenu();
	newContact();
	firmChange();
	serviceTypeChange();
	customerTypeChange();
	calibrationServiceTypeValidation();

	//FOLD PRODUCT INFO
	$(".true .incartProduct.class").on("click", toggleProductInfo);

	//CUSTOM FILEUPLOAD DROPZONEJS
	initDropZone("#dropZoneContainer");
	initMultiDropZone(".multi");
	$(".formStep0#ordersubmit .submitBtn").on("click", submitStep0);
	$(".formStep0#ordersubmit.false .dummy").on("click", multiSubmitStep0);
	$(".formStep0#ordersubmit.true .dummy").on("click", multiSubmitStep0);

	//INPUT FIELD
	$("#NewContactName").on("input", newContactNameInCustomerName);
	checkNewsletter();
	$(".newsradio").on("click", checkNewsletter);

	//PRODUCT SEARCH
	productSearch();
	searchWarmUp();
	$("#searchResult").on("click", addProductToPreview);
	$(".productPreview .remove").on("click", removeProductFromPreview);
	$('#SearchTopText').on("keydown", navigateSearch);

	//LOGIN
	$(".button.forget").on("click", toggleForgottenPassword);	
	forgottenConfirmation();
    
    //MGA
    //Call UPS service
    UPSlookup();
    $("#EcomOrderCustomerZip").on("change", UPSlookup);
    $("#PostLabel").on("click", UPSlookup);

    //RESPONSIVE MENU
    $(".collapseBtn").on("click", toggleResponsiveMenu);
});